import { PaymentProviderEnum } from '@pepperhq/types-sdk';

export function getCardTypeByIssuer(issuer?: string) {
    if (!issuer) {
        return undefined;
    }
    const paymentOptions = ['visa', 'mastercard', 'maestro', 'amex'];

    return paymentOptions.find(option => issuer.toLowerCase().includes(option))?.toUpperCase();
}

/**
 * Standalone providers have their own UI to handle payments,
 * for now it's just Dojo
 */
export const isStandAlonePaymentProvider = (paymentProvider?: string) => {
    if (!paymentProvider) {
        return false;
    }
    return paymentProvider === PaymentProviderEnum.DOJO;
};
